import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebNumeracyFormula({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [choices, setChoices] = useState({});
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [answerBox, setAnswerBox] = useState(data.answerBox);
    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);
    const [availableChoices, setAvailableChoices] = useState(makeArrayRandom(data.choices));

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setChoices({});
        setSelectedChoice(null);
        setAnswerBox(data.answerBox);
        setSelectedKeyPrevious(null);
        setAvailableChoices(makeArrayRandom(data.choices));
    }, [question,
        data.answerBox,
        data.choices
    ]);
    

    const handleChoiceClick = (choice) => {
        setSelectedChoice(choice);
        setSelectedKeyPrevious(null);
    };

    const handleChoiceAssign = (index) => {
        if (choices[index] && !selectedChoice) {
            const choice = data.choices.find((c) => c.value === choices[index].value);
            setSelectedChoice(choice);
            setSelectedKeyPrevious(index);
        }

        if (selectedChoice && (selectedChoice?.value !== choices[index]?.value)) {
            let currentChoices = {...choices};
            const previousChoice = choices[index];

            if (previousChoice) {
                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    { ...previousChoice },
                ]);
            }

            // we will check here if coming from previous answer
            if (selectedKeyPrevious !== null) {
                delete currentChoices[selectedKeyPrevious];
                setSelectedKeyPrevious(null);
            }
            // updating answer
            currentChoices = {
                ...currentChoices,
                [index]: {
                    value: selectedChoice.value,
                },
            }
            setChoices(currentChoices);

            if (
                typeof questionData.answer.value === "object" &&
                !Array.isArray(questionData.answer.value)
            ) {
                const answerKeys = Object.keys(questionData.answer.value);

                const formattedAnswer = answerKeys.reduce(
                    (acc, key, keyIndex) => {
                        acc[key] = currentChoices[key]?.value || null;
                        return acc;
                    },
                    {}
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: formattedAnswer,
                });
            } else {
                const updatedAnswer = Object.values(currentChoices).map(
                    (choice) => choice.value
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: updatedAnswer,
                });
            }

            setAvailableChoices((prevChoices) =>
                prevChoices.filter(
                    (item) => item.value !== selectedChoice.value
                )
            );

            setSelectedChoice(null);
        }
    };

    const handleRemoveChoice = (index) => {
        const removedChoice = choices[index];
        
        if (removedChoice) {
            setChoices((prevChoices) => {
                const newChoices = { ...prevChoices };
                delete newChoices[index];

                if (
                    typeof questionData.answer.value === "object" &&
                    !Array.isArray(questionData.answer.value)
                ) {
                    const answerKeys = Object.keys(
                        questionData.answer.value
                    );

                    let canProceed = false;
                    const formattedAnswer = answerKeys.reduce(
                        (acc, key, keyIndex) => {
                            acc[key] = newChoices[key]?.value || null;
                            if (acc[key] !== null && acc[key] !== "") {
                                canProceed = true;
                            }
                            return acc;
                        },
                        {}
                    );
                    onAnswer({
                        canProceed,
                        answer: formattedAnswer,
                    });
                } else {
                    const updatedAnswer = Object.values(newChoices).map(
                        (choice) => choice.value
                    );

                    // set to false so that next button will be disabled
                    const canProceed = false;
                    onAnswer({
                        canProceed,
                        answer: updatedAnswer,
                    });
                }

                return newChoices;
            });

            setAvailableChoices((prevChoices) => [
                ...prevChoices,
                {
                    value: removedChoice.value,
                },
            ]);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                textAlign: "center",
                // width: "1000px",
                // margin: "0 auto",
            }}
        >
            <Box sx={{
                display: "flex",
                position: "relative",
                textAlign: "center",
            }}> 
                {/* For Answer */}
                <Box sx={{
                    width: "380px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    padding: "10px",
                    backgroundColor: "rgb(122, 140, 142)",
                    borderBottom: "10px solid rgb(91, 105, 107)",
                    borderRadius: "10px",
                    textAlign: "center",
                }}>
                    {answerBox.map((answer, index) => (
                        <Box 
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        >
                            <span>{answer.value}</span>
                            <Box sx={{
                                marginLeft: "4px",
                                height: "30px",
                                width: "140px",
                                position: "relative",
                                display: "inline-block",
                                boxSizing: "border-box",
                                padding: "4px",
                                lineHeight: "0.8em",
                                fontWeight: "bold",
                                textAlign: "center",
                                boxShadow:
                                    selectedChoice
                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                        : "none",
                                backgroundColor: choices[answer.stateKey]
                                        ? "#aad6e7"
                                        : "white",
                                borderTop: choices[answer.stateKey]
                                        ? "none"
                                        : "10px solid rgb(91, 105, 106)",
                                }}
                                onClick={() => handleChoiceAssign(answer.stateKey)}
                            >
                                {choices[answer.stateKey] ? (
                                    <Box
                                        sx={{
                                            top: "initial",
                                            position: "absolute",
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            lineHeight: "0.8em",
                                            fontWeight: "bold",
                                            fontSize: "55px",
                                            textAlign: "center"
                                        }}
                                    >
                                        <Box sx={{
                                            position: "relative",
                                            lineHeight: "1em",
                                            fontWeight: "bold",
                                            fontSize: "20px",
                                            height: "22px",
                                            width: "130px",
                                            display: "inline-block",
                                            boxSizing: "content-box",
                                            backgroundColor: "#aad6e7",
                                            padding: "4px",
                                            textAlign: "center",
                                        }}>
                                            <Box sx={{
                                                display: "inline-flex",
                                                width: "100%",
                                                height: "100%",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                userSelect: "none",
                                                pointerEvents: "none",
                                                fontSize: "16px",
                                                lineHeight: "1em",
                                                fontWeight: "bold",
                                                textAlign: "center"
                                            }}>{choices[answer.stateKey].value}</Box>
                                        </Box>
                                        {/* Close  */}
                                        <Box
                                            className="selected-close-btn"
                                            sx={{
                                                right: "0px",
                                                top: "20px",
                                                display: "content-box",
                                                lineHeight: "0.8em",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleRemoveChoice(answer.stateKey);
                                            }}
                                        >X</Box>
                                    </Box>
                                        ) :
                                        <span></span>
                                    }
                            </Box>
                        </Box>
                    ))}
                </Box>

                {/* For Choices */}
                <Box sx={{
                    marginLeft: "10px",
                    textAlign: "center",
                    width: "380px",
                }}>
                    <Box component="img" src={`${imagesResources}${data.image}`} sx={{ textAlign: "center", width: "300px" }} alt="Img"/>
                    <Box sx={{
                        position: "relative",
                        width: "450px",
                        height: "240px",
                        padding: "10px",
                        marginTop: "10px",
                        border: "1px dashed lightgrey",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                    }}>
                        <Box sx={{
                            position: "relative",
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "10px",
                            top: "0",
                            left: "0",
                            textAlign: "center",
                        }}>
                            {availableChoices.map((choice, index) => (
                                <Box 
                                    key= {index}
                                    sx={{
                                        borderBottom: "10px solid rgb(52, 148, 186)",
                                        position: "relative",
                                        height: "18px",
                                        width: "140px",
                                        display: "inline-block",
                                        boxSizing: "content-box",
                                        backgroundColor: "#aad6e7",
                                        padding: "4px",
                                        lineHeight: "0.8em",
                                        textAlign: "center",
                                        boxShadow:
                                        selectedChoice?.value === choice.value
                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                            : "none",
                                        fontSize: "18px",
                                    }}
                                    onClick={() => { handleChoiceClick(choice) }}
                                    disabled={selectedChoice === choice}
                                >
                                    <Box sx={{
                                        fontWeight: "bold",
                                        display: "inline-flex",
                                        width: "100%",
                                        height: "100%",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        userSelect: "none",
                                        pointerEvents: "none",
                                        fontSize: "16px",
                                        lineHeight: "0.8em",
                                        textAlign: "center",
                                    }}>{choice.value}</Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};